const navValues = {
  login: "Login",
  logout: "Logout",
  shop: "Shop",
  basket: "Basket",
  checkout: "Checkout", 
};

export default navValues;
